import { render, staticRenderFns } from "./ViewTags.vue?vue&type=template&id=30d85570"
import script from "./ViewTags.vue?vue&type=script&lang=js"
export * from "./ViewTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports